import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const prizesApi = createApi({
  reducerPath: 'prizesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PrizeId', 'Prizes'],
  endpoints: () => ({}),
});
